import { upperFirst } from 'lodash/fp';

type StaticIds =
	| 'btnNotificationAvailable'
	| 'btnNotificationButtonInProcess'
	| 'btnPaymentSubmitAutoSaved'
	| 'btnPaymentSubmitAutoSelected'
	| 'btnPaymentSubmitManualSaved'
	| 'btnPaymentSubmitManualSelected'
	| 'btnCookieSubmitAll'
	| 'linkCookiePrivacySetting'
	| 'linkCookieMoreInfo'
	| 'btnInvestmentLandingHero'
	| 'btnInvestmentLandingCta1'
	| 'btnInvestmentLandingCta2'
	| 'btnInvestmentRegistrationStartLight'
	| 'btnInvestmentRegistrationStartFull'
	| 'btnInvestmentRegistrationRedirect'
	| 'tglInvestmentSwitch'
	| 'btnInvestmentIndigoRedirect'
	| 'linkInvestmentAdminManage'
	| 'linkInvestmentAdminAbout'
	| 'btnOverviewPaymentTutorial';

export type IdsWithNumber = 'cookie_bar_v{# version}';

export type IdsWithText =
	| 'menuSelfcare{Text}'
	| 'menuMainweb{Text}'
	| 'taleInvestmentVariant{value}';

export type analyticsId = StaticIds | IdsWithNumber | IdsWithText;

export const MENU_SELF_CARE_PREFIX = 'menuSelfcare';
export const MENU_MAIN_WEB_PREFIX = 'menuMainweb';

export function getAnalyticsName(unformated: string, prefix: string, postfix = ''): string {
	const parsed = upperFirst(unformated.replace(/\//g, '_').replace(/-/g, '_'));
	const formated = parsed.split('_').map(upperFirst).join('');

	return `${prefix}${formated}${postfix}`;
}
